import React, { useState, useEffect } from 'react'
import { Route, useHistory } from 'react-router-dom'
import Row from 'antd/lib/row'
import Col from 'antd/lib/col'
import Tooltip from 'antd/lib/tooltip'
import { CloseOutlined } from '@ant-design/icons'
import DiscountTabs from './DiscountTabs'
import Codes from './Codes'
import Loading from '../Utils/Loading'
import DiscountForm from './DiscountForm'
import { useGlobalQuery } from 'hooks/useGlobalQuery'
import { StyledDrawer } from 'components/Common'
import { DiscountType } from './types'

const Discounts = () => {
  const history = useHistory()
  const { isLoading } = useGlobalQuery()

  const [drawerVisible, setDrawerVisible] = useState(false)
  const [drawerTitle, setDrawerTitle] = useState('Discount')

  const setDrawerVisibility = (visible: boolean) => {
    setDrawerVisible(visible)
  }

  useEffect(() => {
    // Revert to the original logic when Intermediate page is ready to use
    // if (history.location.pathname.includes('discounts/code/edit'))
    if (
      history.location.pathname.includes('discounts/code/edit') ||
      history.location.pathname.includes('discounts/code/new')
    )
      return setDrawerVisible(true)
  }, [history.location.pathname])

  if (isLoading) return <Loading />

  // Remove this when Intermediate page is ready to use
  const DiscountFormRoutes = () => (
    <>
      <Route
        path='/discounts/code/new'
        component={() => {
          setDrawerTitle('Add Discount')
          return <DiscountForm setDrawerVisibility={setDrawerVisibility} />
        }}
      />
      <Route
        path='/discounts/code/edit/:discount_id'
        component={() => {
          setDrawerTitle('Update Discount')
          return <DiscountForm setDrawerVisibility={setDrawerVisibility} />
        }}
      />
    </>
  )

  return (
    <>
      <Row data-testid='discounts-component'>
        <Col span={24}>
          <DiscountTabs
            codes={<Codes type={DiscountType.MANUAL} />}
            automatic={<Codes type={DiscountType.AUTOMATIC} />}
            loyalty={<Codes type={DiscountType.LOYALTY} />}
          />
        </Col>
      </Row>
      <StyledDrawer
        open={drawerVisible}
        onClose={() => {
          setDrawerVisible(false)
          history.replace('/discounts')
        }}
        width={720}
        title={drawerTitle}
        // title='Update Discount'
        data-testid='discounts-form'
        closeIcon={
          <Tooltip title={<span>Be sure to hit save! </span>}>
            <CloseOutlined className='close-icon' />
          </Tooltip>
        }
        className='discounts-drawer'
      >
        {/* Remove this when Intermediate page is ready to use */}
        <DiscountFormRoutes />
        {/* <DiscountForm setDrawerVisibility={setDrawerVisibility} /> */}
      </StyledDrawer>
    </>
  )
}

export default Discounts
